"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.URN = void 0;
/**
 * Uniform Resource Name
 * @link https://datatracker.ietf.org/doc/html/rfc2141
 */
class URN {
    /**
     * Namespace Identifier
     * @link https://datatracker.ietf.org/doc/html/rfc2141#section-2.1
     */
    nid;
    /**
     * Namespace Specific String
     * @link https://datatracker.ietf.org/doc/html/rfc2141#section-2.2
     */
    nss;
    constructor(value) {
        if (typeof value === 'string') {
            const parsed = URN.parse(value);
            this.nss = parsed.nss;
            this.nid = parsed.nid;
        }
        else {
            this.nid = value.nid;
            this.nss = value.nss;
        }
    }
    get href() {
        return this.toString();
    }
    get protocol() {
        return 'urn:';
    }
    toString() {
        return this.protocol + [this.nid, this.nss].join(':');
    }
    static canParse(urn) {
        return typeof urn === 'string' && urn.startsWith('urn:');
    }
    static parse(urn) {
        const url = new URL(urn);
        if (url.protocol !== 'urn:') {
            throw new TypeError('Failed to construct URN');
        }
        const nidIdx = url.pathname.indexOf(':');
        const nid = url.pathname.substring(0, nidIdx);
        const nss = url.pathname.substring(nidIdx + 1);
        if (!nid) {
            throw new TypeError('Failed to construct URN');
        }
        return { search: url.search, hash: url.hash, nid, nss };
    }
}
exports.URN = URN;
